import * as React from "react"
import styled from "styled-components"
import { Icon } from "../../components/Icon"
import { colors, scale } from "../../styles"

export interface FilterCheckboxProps {
	withoutBorder?: boolean
	onChange?: React.ChangeEventHandler<HTMLInputElement>
	disabled?: boolean
	id?: string
	name?: string
	value?: string
	checked?: boolean
	label?: string
	inputRef?: React.Ref<HTMLInputElement>
	hits?: number
	defaultChecked?: boolean
}

export interface LabelStyledProps {
	disabled?: boolean
}

const LabelStyled = styled.label<LabelStyledProps>`
	position: relative;
	display: inline-flex;
	cursor: pointer;
	user-select: none;
	font-size: ${scale.px(1.75)};
	line-height: ${scale.px(2)};
	font-weight: bold;
	color: ${colors.navy};
`

export const LabelTextStyled = styled.span`
	padding-left: ${scale.px(1)};
	padding-top: 1px;
`

export const CustomInputInner = styled.div`
	display: flex;
	align-items: center;
	padding: ${scale.px(1.25)};

	// Checkbox square
	&:before {
		content: "";
		display: inline-block;
		width: ${scale.px(1.5)};
		height: ${scale.px(1.5)};
		border-radius: 2px;
		border: 1px solid ${colors.navy};
	}
`

const CustomInputStyled = styled.div<{
	border: boolean
}>`
	position: relative;
	background-color: ${colors.white};
	border: ${({ border }) =>
		border ? `1px solid ${colors.blue33}` : `1px solid transparent`};
	border-radius: ${scale.px(0.5)};

	// Checkbox checkmark
	svg {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: ${scale.px(1)};
		opacity: 0;
	}

	&:hover {
		color: ${colors.hoverBlue};
		border-color: ${colors.hoverBlue};

		${CustomInputInner} {
			:before {
				border-color: ${colors.hoverBlue};
			}
		}
	}
`

const InputStyled = styled.input.attrs({ type: "checkbox" })`
	border: 0;
	outline: 0;
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	white-space: nowrap;
	width: 1px;

	&:focus + ${CustomInputStyled} {
		border: 1px solid ${colors.hoverBlue};

		${LabelTextStyled} {
			color: ${colors.hoverBlue};
		}
	}

	&:checked + .checkbox {
		border-color: ${colors.navy};
		background-color: ${colors.navy};
		color: ${colors.white};

		svg {
			fill: ${colors.white};
			opacity: 1;
		}

		${CustomInputInner}:before {
			border-color: ${colors.navy};
		}
	}
`

const FilterCheckbox: React.FC<FilterCheckboxProps> = ({
	withoutBorder = false,
	label,
	id,
	disabled,
	inputRef,
	hits,
	...rest
}) => (
	<LabelStyled disabled={disabled} htmlFor={id}>
		<InputStyled ref={inputRef} id={id} disabled={disabled} {...rest} />
		<CustomInputStyled className="checkbox" border={!withoutBorder}>
			<Icon icon="check" size={2} color="white" />
			<CustomInputInner>
				<LabelTextStyled>
					{label}
					{hits && ` (${hits})`}
				</LabelTextStyled>
			</CustomInputInner>
		</CustomInputStyled>
	</LabelStyled>
)

export { FilterCheckbox }
